<template>
  <div class="redbag">
    <button @click="handleJump" v-if="!isWeixin"></button>
    <button @click="handleCopy" v-else></button>
  </div>
</template>

<script>
  import {mapActions, mapGetters, mapState} from 'vuex'

  export default {
    name: 'RedBag',
    props: {
      pwd: {
        type: String
      },
      url: {
        type: String
      },
      copyTemp: {
        type: String
      }
    },
    computed: {
      ...mapState([
        'mainActData'
      ]),
      ...mapGetters([
        'isWeixin',
      ]),
      text () {
        return this.copyTemp ? this.copyTemp.replace(/\[PWD\]/, this.mainActData.pwd) : this.mainActData.pwd
      }
    },
    methods: {
      ...mapActions(['handleJumpAction', 'handleCopyAction']),
      handleJump () {
        this.handleJumpAction({
          url: this.mainActData.url
        })
      },
      handleCopy () {
        this.handleCopyAction({
          copyText: this.text,
          errText: '复制失败，请在手机自带浏览器里打开'
        })
      },
    }
  }
</script>

<style scoped lang="less">
.redbag {
  position: fixed;
  z-index: 99;
  right: .3rem;
  bottom: 1.5rem;
  button {
    background: url(//xwstatic.js571.com/2019/activity/1111/redbag.png) no-repeat center center;
    background-size: cover;
    width: 1.32rem;
    height: 1.54rem;
    border: none;
    animation: shake infinite linear 1s;
  }
}
@keyframes shake {
  60% {
    transform: scale(1);
  }
  70% {
    transform: scale(1.1);
  }
  80% {
    transform: scale(1);
  }
  90% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}
</style>
